import { Download, MessageCircle } from "lucide-react";
import { CATEGORIES, waLink } from "../data/catalogue";
import { Reveal } from "./Shared";

const askMsg = (title) =>
  `Hi Anubandh! I'm interested in the ${title} catalogue. Could you share pricing details?`;

export default function Collections() {
  return (
    <section id="collections" data-testid="collections-section" className="scroll-mt-24 py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <Reveal>
            <p className="text-xs font-semibold uppercase tracking-[0.24em] text-coral">
              The Catalogues
            </p>
            <h2 className="mt-4 font-serif font-medium tracking-tight text-ink text-4xl sm:text-5xl">
              Six ways to gift<span className="text-sage">.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="max-w-sm text-sm leading-relaxed text-cocoa md:text-right">
              Every catalogue below is yours to download and pass around the team.
              Prices stay personal: ask us on WhatsApp.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid gap-8 md:grid-cols-2">
          {CATEGORIES.map((c, i) => (
            <Reveal
              key={c.id}
              delay={(i % 2) * 0.12}
              className={i % 2 === 1 ? "md:mt-14" : ""}
            >
              <article
                data-testid={`category-card-${c.id}`}
                className="group overflow-hidden rounded-[2rem] border border-sand bg-white shadow-[0_10px_40px_-18px_rgba(43,33,28,0.12)] transition-all duration-500 hover:shadow-[0_30px_60px_-24px_rgba(200,90,68,0.28)] hover:-translate-y-1"
              >
                <div className="relative overflow-hidden">
                  <img
                    src={c.cover}
                    alt={`${c.title} page from the Anubandh catalogue`}
                    loading="lazy"
                    className="aspect-[4/3] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
                  />
                  <span className="absolute left-4 top-4 rounded-full bg-cream/90 backdrop-blur px-3.5 py-1.5 text-[11px] font-semibold uppercase tracking-[0.16em] text-ink">
                    {c.pages} pages
                  </span>
                </div>

                <div className="p-6 sm:p-8">
                  <div className="flex items-baseline justify-between gap-4">
                    <h3 className="font-serif font-semibold text-ink text-2xl sm:text-3xl">
                      {c.title}
                    </h3>
                    <span className="font-display text-coral text-lg shrink-0">{c.hindi}</span>
                  </div>
                  <p className="mt-3 text-sm leading-relaxed text-cocoa">{c.desc}</p>

                  <div className="mt-6 flex flex-wrap items-center gap-3">
                    <a
                      href={c.pdf}
                      download
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={`download-${c.id}-pdf`}
                      className="inline-flex items-center gap-2 rounded-full bg-espresso px-5 py-2.5 text-sm font-medium text-cream hover:bg-coral transition-colors duration-300"
                    >
                      <Download className="h-4 w-4" />
                      Download Catalogue
                    </a>
                    <a
                      href={waLink(askMsg(c.title))}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={`ask-price-${c.id}-whatsapp`}
                      className="inline-flex items-center gap-2 rounded-full border border-sand px-5 py-2.5 text-sm font-medium text-ink hover:border-sage hover:text-sage-deep transition-colors duration-300"
                    >
                      <MessageCircle className="h-4 w-4" />
                      Ask Price
                    </a>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
